import classNames from 'classnames';
import React, { useEffect } from 'react';
import styles from './Adsense.module.css';

interface AdsenseProps {
  className?: string;
  adClient: string;
  adSlot: string;
  style?: React.CSSProperties;
  variant?: 'leaderboard' | 'm-rectangle' | 'l-rectangle';
}

const Adsense: React.FC<AdsenseProps> = ({
  className,
  adClient,
  adSlot,
  variant = 'leaderboard',
  style,
}) => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      try {
        const adsbygoogle =
          window.adsbygoogle ?? ([] as unknown as NonNullable<Window['adsbygoogle']>);
        adsbygoogle.push({});
        window.adsbygoogle = adsbygoogle;
      } catch (e) {
        console.error('Adsense error:', e);
      }
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    return (
      <div className={classNames(styles.root, styles[variant], className)}>
        <div className={classNames(styles.placeholder, styles.ads)} style={style}>
          광고 영역 (개발 환경)
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.root, styles[variant], className)}>
      <ins
        className={classNames('adsbygoogle', styles.ads)}
        style={{ display: 'block', ...style }}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default Adsense;
